import AbstractNode from './AbstractNode';
import {TextSelection} from 'prosemirror-state';

export default class Accordion extends AbstractNode {
    get name() {
        return "accordion";
    }

    get schema() {
        return {
            content: "accordion_title accordion_content",
            group: "block",
            selectable: true,
            draggable: true,
            parseDOM: [{
              tag: 'div.ui.accordion'
            }],
            toDOM: () => ["div", {'class': 'ui fluid compact accordion'}, 0]
        }
    }

    toMarkdown(state, node) {
        state.flushClose(2);
        state.write('<div class="ui fluid compact accordion">');
        state.ensureNewLine();
        state.renderContent(node);
        state.write('</div>');
        state.ensureNewLine();
        state.closeBlock(node);
    }

    get parseMarkdown() {
        return {
            block: "accordion"
        }
    }

    commands({schema}) {
        return {
            createDetails: () => view => {
                const offset = view.state.tr.selection.anchor + 1;
                const tr = view.state.tr.replaceSelectionWith(schema.nodes.accordion.createAndFill()).scrollIntoView();
                const resolvedPos = tr.doc.resolve(offset);
                view.dispatch(tr.setSelection(TextSelection.near(resolvedPos)));
            }
        };
    }
}